import { getContentfulTargetingIds } from '@thd-olt-component-react/personalization-utils';

const hasIds = ({ mboxes, campaignIds, innervateTags }) => {
  return mboxes.length > 0 || campaignIds.length > 0 || innervateTags.length > 0;
};

export const isReadyUtil = ({ contentfulComponents, serverLayouts = {}, clientLayouts = {}, customerType }) => {
  let mboxes = [];
  let campaignIds = [];
  let innervateTags = [];
  let isReady = false;
  const combinedDataPresent = !!serverLayouts.data && !!clientLayouts.data;

  if (combinedDataPresent || (serverLayouts.data && customerType === 'b2c-guest')) {

    if (contentfulComponents) {
      const targetingIds = getContentfulTargetingIds({
        content: contentfulComponents,
        containerKeys: {
          SpotlightContainer: 'spotlightList'
        }
      });

      isReady = hasIds({ ...targetingIds })
        || false;

      if (customerType === 'b2c-guest') {
        isReady = contentfulComponents
          ? hasIds({ ...targetingIds })
          : false;
      }

      mboxes = targetingIds.mboxes;
      campaignIds = targetingIds.campaignIds;
      innervateTags = targetingIds.innervateTags;
    }
  }

  return {
    mboxes,
    campaignIds,
    innervateTags,
    isReady,
  };
};